.sn-comparison {
  display: flex;
  flex-direction: column;
  gap: map-get($spacings, 2xl);

  &__header {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, md);
    margin-bottom: map-get($spacings, md);

    @include above($breakpoint-desktop-md) {
      gap: map-get($spacings, 2xl);
      margin-bottom: map-get($spacings, 2xl);
    }

    .me-text {
      @include above($breakpoint-desktop-md) {
        max-width: calc(100% * 8 / 12);
      }
    }
  }

  &__table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  &__table {
    width: 100%;
    min-width: 600px;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid var(--border-color-secondary);
    border-radius: 12px;
    overflow: hidden;
    table-layout: auto;
  }

  &__row {
    &--header {
      background-color: var(--background-color-secondary);
    }
  }

  &__cell {
    padding: map-get($spacings, md);
    font-weight: 400;
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);
    color: var(--color-text-primary);
    text-align: left;
    vertical-align: middle;

    // Narrow fixed-layout columns on mobile (feature cell ~85px) can't fit long
    // words like "document" — break them onto the next line instead of overflowing.
    overflow-wrap: break-word;
    border-right: 1px solid var(--border-color-secondary);
    border-bottom: 1px solid var(--border-color-secondary);
    height: 96px;

    @include above($breakpoint-desktop) {
      padding: map-get($spacings, xl);
      font-size: map-get($font-sizes, xl);
    }

    &--header {
      font-weight: 700;
      font-size: map-get($font-sizes, md);
      color: rgb(20 18 18 / 60%);
      height: 76px;

      @include above($breakpoint-desktop) {
        font-size: map-get($font-sizes, xl);
      }
    }

    &--feature {
      font-weight: 700;
      color: var(--text-color-primary);
      width: 33.333%;
    }

    &--value {
      text-align: center;
      width: 33.333%;
    }

    &:last-child {
      border-right: 0;
    }
  }

  &__icon {
    &--check {
      color: var(--text-color-primary);

    }

    &--x {
      .me-icon {
        display: inline-block;

        @include size(14px);

        position: relative;

        &::before,
        &::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          height: 3px;
          background-color: $color-system-error;
          border-radius: 2px;
        }

        &::before {
          transform: translate(-50%, -50%) rotate(45deg);
        }

        &::after {
          transform: translate(-50%, -50%) rotate(-45deg);
        }
      }
    }
  }

  &__value-text {
    font-weight: 400;
    font-size: map-get($font-sizes, sm);
    line-height: map-get($line-heights, md);
    color: var(--color-text-primary);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, md);
    }
  }

  tbody tr:last-child .sn-comparison__cell {
    border-bottom: 0;
  }

  .me-heading--4 {
    font-size: map-get($font-sizes, 2xl);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, 3xl);
    }

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, 4xl);
    }
  }

  .me-heading--6 {
    font-size: 24px;
    line-height: 32px;
  }

  .me-text {
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }
}
